import type { ApiError } from "@base/model/types/error";
import { isAxiosError } from "axios";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const isBrowser = typeof window !== "undefined";

export const getCookie = (name: string) => {
  if (!isBrowser) {
    return null;
  }

  if (!document.cookie || document.cookie === "") {
    return null;
  }

  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const trimmedCookie = cookie.trim();
    if (trimmedCookie.substring(0, name.length + 1) !== `${name}=`) {
      continue;
    }

    return decodeURIComponent(trimmedCookie.substring(name.length + 1));
  }

  return null;
};

export const isApiError = (error: unknown): error is ApiError => {
  return (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    typeof (error as ApiError).status === "number" &&
    "message" in error &&
    typeof (error as ApiError).message === "string" &&
    "code" in error &&
    typeof (error as ApiError).code === "string"
  );
};

export const isAxiosApiError = (error: unknown): error is { response: { data: ApiError } } => {
  return isAxiosError(error) && error.response?.data && isApiError(error.response.data);
};
